import { type ReactNode } from 'react'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import AppSidebar from './AppSidebar'
import AppHeader from './AppHeader'
import AppFooter from './AppFooter'
import HealthBanner from './HealthBanner'
import { UiFlagsProvider } from '@/contexts/UiFlagsContext'
import { WindowManagerProvider } from '@/contexts/WindowManagerContext'
import { WindowManagerOverlay } from './incidents/WindowManagerOverlay'
import { useGlobalKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts' // PROJ-051: Global keyboard shortcuts

interface AppLayoutProps {
  children: ReactNode
  initials: string
  onLogin: () => void
  onLogout: () => void
  bgVariant: 'none' | 'dots' | 'lines' | 'cross'
  onBgVariantChange: (variant: 'none' | 'dots' | 'lines' | 'cross') => void
  showGrid: boolean
  onShowGridChange: (show: boolean) => void
  showDevtools: boolean
  onShowDevtoolsChange: (show: boolean) => void
}

export default function AppLayout({
  children,
  initials,
  onLogin,
  onLogout,
  bgVariant,
  onBgVariantChange,
  showGrid,
  onShowGridChange,
  showDevtools,
  onShowDevtoolsChange,
}: AppLayoutProps) {
  // PROJ-051: Enable global keyboard shortcuts (Ctrl+Shift+N for Network Diagnostics)
  useGlobalKeyboardShortcuts()

  return (
    <UiFlagsProvider>
      <WindowManagerProvider>
        <SidebarProvider>
          <AppSidebar initials={initials} onLogin={onLogin} onLogout={onLogout} />
          <SidebarInset>
            <AppHeader
              bgVariant={bgVariant}
              onBgVariantChange={onBgVariantChange}
              showGrid={showGrid}
              onShowGridChange={onShowGridChange}
              showDevtools={showDevtools}
              onShowDevtoolsChange={onShowDevtoolsChange}
            />
            <HealthBanner />
            <div className="flex flex-1 flex-col">{children}</div>
            <AppFooter />
          </SidebarInset>
        </SidebarProvider>
        {/* Multi-Window Overlay */}
        <WindowManagerOverlay />
      </WindowManagerProvider>
    </UiFlagsProvider>
  )
}
